import { assetsDashboardsListEntryPoint as assetsDashboardsListEntryPointSpa } from '@jira/cmdb-assets-dashboards/src/ui/dashboard-list/entrypoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { assetsDashboardsRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsDashboardsRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';

const assetsDashboardsListPageEntryPoint = createChromelessEntryPoint({
	main: assetsDashboardsListEntryPointSpa,
});

export const assetsDashboardsRouteEntry = createEntry(assetsDashboardsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => assetsDashboardsListPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-dashboards-list-page',
	resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
	forPaint: [LazyAssetsLayout],
	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE,
			packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE),
			teamName: 'ITSM SAGA',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-assets-entries/src/assetsDashboardsRouteEntry.tsx',
			whichExportToUse: 'assetsDashboardsRouteEntry',
		},
		enabled: true,
	},
}));
